import { supplyTypesApi } from "@/api/endpoints";
import { ReferenceNameMasterPage } from "./ReferenceNameMasterPage";

export function SupplyTypesPage() {
  return (
    <ReferenceNameMasterPage
      title="Vendor Supply Types"
      noun="Supply type"
      api={supplyTypesApi}
      queryKey="supply-types"
      permPrefix="procurement.supplytype"
      withItemType={false}
    />
  );
}
